import { useUserConfig } from '@/features/_shared/user';
import { useAppSelector } from '@/store/hooks';

import { useFeatureFlagsLoaded } from '@/services/feature-flags/react';
import { useGlobalLoaderGate } from './useGlobalLoaderGate';
import { useInitialAppQueries } from './useInitialAppQueries';

export const useInitialLoadGate = (isAuthenticated: boolean) => {
  const areFlagsLoaded = useFeatureFlagsLoaded();
  const tripTokenStatus = useAppSelector(state => state.tripToken.status);
  const { isSuccess: isUserConfigLoaded, isError: isUserConfigError } = useUserConfig(
    tripTokenStatus === 'fulfilled'
  );

  const isReadyForData = tripTokenStatus === 'fulfilled' && isUserConfigLoaded;
  const { areMarketsDone, areDashboardsDone } = useInitialAppQueries(
    isAuthenticated && isReadyForData
  );

  const isLoading =
    isAuthenticated &&
    (!areFlagsLoaded ||
      tripTokenStatus === 'idle' ||
      tripTokenStatus === 'loading' ||
      (!isUserConfigLoaded && !isUserConfigError) ||
      (isReadyForData && !(areMarketsDone && areDashboardsDone)));

  useGlobalLoaderGate('app-init', isLoading);

  return isLoading;
};
